// Bootstrap do app: importa tokens/estilos, monta o host de toasts, conecta o
// handler de 401 e inicia o router.
// Font Awesome Pro: kit self-hosted em public/fa/, carregado por <link> no
// index.html (arquivos de public/ não passam pelo pipeline do Vite).
// Sem CDN — a PWA funciona offline. Só regular e solid; ver scripts/atualiza-fa.sh.
import '@mind/tokens/tokens.css';
import '@mind/tokens/base.css';
import './styles/app.css';

import { startRouter, navigate } from './router.js';
import { setUnauthorizedHandler } from './api/http.js';
import { $user } from './stores/auth.js';
import { mountToastHost } from './components/toast-host.js';

// 401 global: limpa a sessão e manda ao login preservando o destino.
setUnauthorizedHandler(() => {
  $user.set(null);
  if (location.pathname !== '/login') {
    const next = encodeURIComponent(location.pathname + location.search);
    navigate(`/login?next=${next}`, true);
  }
});

// Host de toasts (montado uma vez, fora do #app para não ser limpo pelo router).
const toastRoot = document.createElement('div');
document.body.appendChild(toastRoot);
mountToastHost(toastRoot);

const app = document.getElementById('app');
if (!app) throw new Error('#app não encontrado');
startRouter(app);

// PWA: registra o service worker de auto-atualização só em produção (Fase 7).
if (import.meta.env.PROD) {
  import('./lib/sw-update.js').then((m) => m.initSwUpdate()).catch(() => {});
  // Re-sincroniza a subscrição de push se o usuário já concedeu permissão.
  import('./lib/push.js').then((m) => m.syncPush()).catch(() => {});
}
